export default {
  BusinessPurchaseOrder: {
    header: {
      code: 'Purchase Order No.',
      supplier: 'Supplier',
      supplierText: 'Supplier Code/Name',
      type: 'Purchase Type',
      warehouseCode: 'Receiving Warehouse',
      status: 'Purchase Order Status',
      stockinStatus: 'Storage Status',
      commodityCode: 'Product Code',
      skuCode: 'SKU',
      startData: 'Start Date',
      endData: 'End Date',
      expectedData: 'Expected Arrival Time',
      finishData: 'Completion Date',
      buyerName: 'Purchaser',
      creationDate: 'Creation Date'
    },

    purchaseOrderAdd: 'Add Purchase Order',
    purchaseOrderExport: 'Import Purchase Order',
    modify: 'Edit',
    review: 'Review',
    antiAudit: 'Anti audit',
    purchaseOk: 'Complete Purchase',
    finish: 'Complete',
    cancelPurchase: 'Cancel Purchase Order',
    errorText: 'There are documents with incorrect status, unable to perform current operation.',
    msgError: 'Only documents with pending approval status can be edited.',
    msgBox1: 'Whether',
    msgBox2: 'Selected Documents',

    exportData: {
      export: 'Export',
      downName: 'Purchase Order Import Template',
      downExport: 'Purchase Order Export',
      rule: 'Excel Import Purchase Order Rule Explanation',
      p1: 'Purchase Order Information: Supplier, Purchase Type, Receiving Warehouse, Payment Method. Purchase orders with identical information will be automatically merged into one, otherwise they will be split into different purchase orders. Suppliers and SKU codes that do not exist or are disabled cannot be imported.',
      p2: 'Import template, click to download',
      title: 'Purchase Order Import Template',
      p3: 'The imported Excel format must have a title, and the red title is required',
      p4: 'Supported file formats: csv, xls, xlsx. The file size for a single import cannot exceed 128MB and the number of data rows cannot exceed 50,000. If it does, please divide into multiple imports.',
    },

    table: {
      code: 'Purchase Order No.',
      typeMeaning: 'Purchase Type',
      supplierCode: 'Supplier Code',
      supplierName: 'Supplier Name',
      warehouseName: 'Receiving Warehouse',
      statusMeaning: 'Receiving Warehouse',
      stockinStatusMeaning: 'Storage Status',
      expectedDate: 'Expected Arrival Time',
      paymentType: 'Payment Method',
      planQty: 'Purchase Quantity',
      amount: 'Total Amount',
      alreadyQty: 'Inbound Quantity',
      waitQty: 'Unreceived Quantity',
      cancelQty: 'Stop waiting quantity',
      packagingFlag: 'Whether it contains packaging',
      shippingFlag: 'Whether free shipping',
      logisticsBusinessName: 'Logistics Company',
      logisticsNo: 'Waybill Number',
      logisticsAmount: 'Shipping cost',
      overfillRate: 'Overfill Ratio',
      buyerName: 'Purchaser',
      remark: 'Remark',
      finishTime: 'Complete Time',
      auditTime: 'Review Time',
      auditName: 'Reviewer',
      sourceCode: 'Source Order No.',
      sourceMeaning: 'Source'
    }
  },
  BusinessPurchaseOrder2: {
    code: 'Receipt No.',
    thirdCode: 'Ref.No',
    totalItem: 'Total Items',
    data: 'Data',
    arrivedAt: 'Arrival Date',
    receiveDate: 'ETA',
    dropOffMethod: 'Drop-off Method',
    side: 'Side Loader',
    trailer: 'Trailer',
    externalPo: 'Ref. No.',
    means: 'Shipping Method',
    Unit: 'Shipping Unit',
    container: 'Container ID/Ref.No.',
    detailTitle: 'Receipt Information',
    updateStatus: 'Update Status',
    hintMsg: 'Only orders whose status is New can be deleted',
    hintMsge: "only orders with 'UploadFailure' and 'New' status are allowed to be synchronized",
    timeErrorTip: 'Date format error',
    FclRdyDate: 'Fcl_Rdy Date',
    FclPickDate: 'Fcl_Picked Date',
    ConEmpDate: 'Container Empty Date',
    ConCollDate: 'Container Collection Date',
    form: {
      thirdCode: 'Reference No.',
      vendorId: 'Vendor ID',
      vendorName: 'Reference Vendor Name',
      shippingMethod: 'Shipping Method',
      palletQty: 'Pallet Quantity',
      containerId: 'Container ID',
      isTrue: 'Container ID Is Correct',
      newContainerId: 'New Container ID',
      containerType: 'Container Type',
      containerLength: 'Container Length',
      batchCode: 'Batch',
      expiryDate: 'Expiry Date',
      carton: 'Carton Quantity',
      skuName: 'Product Name',
    },
    detail: {
      poNumber: 'Receipt No',
      isWrapNo: 'Is Wrap No',
      wrapQty: 'Wrap Qty',
      cartonQty: 'Carton Qty',
      palletAvg: 'Pallet Avg Height',
    },
    dialog: {
      arrivedBtn: 'Arrived',
      verifyBtn: 'Verify',
      receiveBtn: 'Receive',
      fclRdyBtn: 'Fcl Rdy',
      fclPickBtn: 'Fcl Pick',
      pushBtn: 'Push To WMS',
      POId: 'Inbound Receipt No',
      containerId: 'Container ID',
      hint: 'Please comfirm',
      hint1: 'Are you sure that the container',
      hint11: 'is ready to pick.',
      hint2: 'Are you sure about the purchase order',
      hint22: 'is arrived?',
      correctBtn: 'Correct',
      wrongBtn: 'Wrong',
      inputText: 'Please select the arriving date',
      arriveDate: 'Arriving Date',
      inputText2: 'Please enter the correct container ID',
      containerEndTime: 'Picked Date',
      inputText3: 'Please select FCL picked date',
      errMsg1: 'Is the container ID correct?',
      errMsg2: 'The current state cannot be canceled',
      errMsg3: 'The required fields in the form cannot be left blank',
      errMsg4: 'Please add the product first',
    }
  },

  BusinessPurchaseOrder3: {
    Ps1: 'The extra labor time here do not include the SKU labeling fee and SKU sorting fee.',
    PO: 'Shipping Method',
    Container: 'Container',
    Pallets: 'Pallets',
    Carton: 'Carton',
    Loose: 'Loose',
    Pallet: 'Pallet',
    Not: 'Not Verified',
    pass: 'Verification Passed',
    Fail: 'Verification Failed',
    Type: 'Container Type',
    Size: 'Container Size',
    Lift: 'Lift-Off Pallet Qty',
    Loscom: 'Loscam',
    nonStandard: 'non-standard',
    Putaway: 'Putaway Pallet Qty',
    Total: 'Total Pallet Qty',
    Standard: 'Standard',
    Chep: 'Chep',
    Hire: 'CSG Pallet Qty',
    cartonQty: 'Carton Qty',
    Shrip: 'Shrink Wrap Qty',
    Extra: 'Extra Labour Time(min)',
    comments: 'Comments',
    PARTIAL: 'PARTIAL RECEIVED',
    FULLY: 'FULLY RECEIVED',
    Submit: 'Submit Date',
    Submitter: 'Submitter',
    ps: 'Total Pallet Qty must be equal to  Standard Pallet Qty  +  Chep Pallet Qty +  Loscam Pallet Qty  +  CSG Pallet Qty',
    id: 'Internals ID',
    Status: 'Status',
    warehouseReceiptRemarks: 'Warehouse Receiving Remarks',
    Date: 'Date',
    Item: 'Item Count',
    ContainerId: 'Container ID',
    PalletQty: 'Pallet Qty',
    Avg: 'Pallet Avg Height',
    Product: 'Product Name',
    Expiry: 'Expiry',
    Qty: 'Quantity',
    ExpectedQty: 'Expected Qty',
    PendingQty: 'Pending Putaway',
    StockedQty: 'Stocked',
    FinalQty: 'Final',
    Batch: 'Batch',
    Vendor: 'Vendor SKU',
    Received: 'Received',
    Received1: 'Received Qty',
    Downloadstatus: 'Download status',
    Receiveds: 'Received Qty',
    IsChecked: 'IsChecked',
    IsConfirm: 'IsConfirm',
    Warehouse: 'Warehouse Receipt Information',
    CustomerPalletQty: 'Customer Pallet Qty'
  }
};
